import React from 'react'
import MenuMenu from 'semantic-ui-react/dist/es/collections/Menu/MenuMenu'

const VmoMenuMenu = (props) => (
    <MenuMenu {...props}>{props.children}</MenuMenu>
)
export default VmoMenuMenu